module.exports = __webpack_public_path__ + "static/media/coach.226a95ee.jpg";